import { render, staticRenderFns } from "./CategoryEditor.vue?vue&type=template&id=116cc195"
import script from "./CategoryEditor.vue?vue&type=script&lang=js"
export * from "./CategoryEditor.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditor.vue?vue&type=style&index=0&id=116cc195&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports